import { CUSTOM_DATES, DATE } from './fields'
import { formatDateToBE } from '../../../../../../constants/dates'

export const transformValuesToBE = values => {
  return {
    [CUSTOM_DATES]: values[CUSTOM_DATES].filter(item => !!item[DATE]).map(item => formatDateToBE(new Date(item[DATE])))
  }
}
